export const STUDENT_LIST_REQUEST = 'STUDENT_LIST_REQUEST'
export const STUDENT_LIST_SUCCESS = 'STUDENT_LIST_SUCCESS'
export const STUDENT_LIST_FAILURE = 'STUDENT_LIST_FAILURE'

export const STUDENT_LIST_NAMES = 'STUDENT_LIST_NAMES'

export const STUDENT_DETAILS_REQUEST = 'STUDENT_DETAILS_REQUEST'
export const STUDENT_DETAILS_SUCCESS = 'STUDENT_DETAILS_SUCCESS'
export const STUDENT_DETAILS_FAILURE = 'STUDENT_DETAILS_FAILURE'

export const STUDENT_DETAILS_ADD_TAG = 'STUDENT_DETAILS_ADD_TAG'
export const STUDENT_DETAILS_REMOVE_TAG = 'STUDENT_DETAILS_REMOVE_TAG'